export class I18N {
	static localeAliases = {
		'de': 'de-DE',
		'de-DE': 'de-DE',
		'de-de': 'de-DE',
		'en': 'en-US',
		'en-US': 'en-US',
	}
	static userLang = navigator.language ? I18N.localeAliases[navigator.language] : false || navigator.userLanguage ? I18N.localeAliases[navigator.userLanguage] : false

	static translations = {
		'de-DE': {
			'yes': 'ja',
			'no': 'nein',
			'Shop': 'Markt',
			'Stores': 'Anbieter',
			'Store': 'Anbieter',
			'Store Address': 'Anbieteradresse',
			'Products': 'Produkte',
			'Net': 'Netto',
			'Tax': 'MwSt',
			'Gross': 'Preis',
			'Add to Cart': '<span class="material-icons-outlined">add_shopping_cart</span>',
			'Select': '<span class="material-icons">menu_book</span>',
			'Add to Cart ': 'In den Warenkorb',
			'Base Price': 'Basispreis',
			'Remarks': 'Bemerkungen',
			'Rem.': 'Bem.',
			'Quantity': 'Anzahl',
			'Total Price': 'Gesamtpreis',
			'Close': 'Schließen',
			'Close ': '<span class="material-icons">close</span>',
			'Cart': 'Warenkorb',
			'Remove': '<span class="material-icons">remove</span>',
			'Remove ': 'entfernen',
			'Items Value': 'Warenwert',
			'mo': 'Mo',
			'tu': 'Di',
			'we': 'Mi',
			'th': 'Do',
			'fr': 'Fr',
			'sa': 'Sa',
			'su': 'So',
			'until': 'bis',
			'closed': 'geschlossen',
			'closed ': 'nur Vorbestellung',
			'only delivery': 'nur Abholung',
			'Order': 'Bestellung',
			'Pickup or Delivery': 'Abholung oder Lieferung',
			'Pickup': 'Abholung',
			'Delivery': 'Lieferung',
			'Immediately or later': 'Sofort oder später',
			'Immediately': 'sofort',
			'Later': 'später',
			'Day': 'Tag',
			'Time': 'Uhrzeit',
			'Name': 'Name',
			'Phone': 'Telefon',
			'E-Mail': 'E-Mail',
			'Street': 'Straße',
			'Nr.': 'Nr.',
			'Postal Code': 'PLZ',
			'City': 'Ort',
			'Country': 'Länderkürzel',
			'Delivery Address': 'Lieferadresse',
			'Costs': 'Kosten',
			'Doorbell': 'Name am Klingelschild',
			'Delivery to GPS Position': 'Lieferung an GPS Position',
			'Pick current GPS Position': 'Aktuelle GPS Position bestimmen',
			'Show on Map': 'Auf Karte zeigen',
			'Please pick or enter GEO coordinates in decimal format!': 'Bitte benutze den GPS Button oder gib deine Geo-Koordianten im Dezimal format ein!',
			'Latitude': 'Breitengrad',
			'Longitude': 'Längengrad',
			'We charge a surcharge for delivery up to the minimum order value. You can choose a few more extras from the card without paying more.': 'Wir berechnen für Lieferung einen Aufschlag bis zum Mindestbestellwert. Du kannst noch ein paar extras von der Karte wählen, ohne mehr zu bezahlen.',
			'Delivery fee saved': 'Liefergebühr gespart',
			'Pickup discount calculated': 'Abholerrabatt berechnet',
			'House number missing!': 'Hausnummer fehlt!',
			'The delivery address was not found on the city map and must be corrected!': 'Die Lieferadresse wurde nicht im Stadtplan gefunden und muss korrigiert werden!',
			'Your address is outside of our delivery radius of 3 km. Choose pickup, arrange a delivery by phone, or extend your order over €50 to get a delivery up to 5km.': 'Deine Adresse liegt außerhalb unseres Lieferradius von 3km. Wähle Abholung, vereinbare telefonisch eine Lieferung oder erweitere deine Bestellung auf mindestens 50€, um eine Lieferung bis zu 5 km zu erhalten.',
			'A technical error occurred. Please try again later, with other input or call us! Problem info:<br>{0}': 'Es ist ein technischer Fehler aufgetreten. Bitte versuche es später noch einmal, versuche andere Eingaben oder ruf uns an. Probleminfo:<br>{0}',
			'{0} missing!': '{0} fehlt!',
			'Please enter your delivery location': 'Bitte gib deinen Lieferort an',
			'FREE_LONG_DISTANCE_DELIVERY': 'Freie Langstreckenlieferung',
			'DELIVERY': 'Liefergebühr',
			'CAMPAIGN': 'Rabattaktion',
			'FREE_DELIVERY': 'Freie Lieferung',
			'MISSING_TO_MIN_VALUE': 'Aufschlag zum Mindestbestellwert',
			'PICKUP': 'Abholerrabatt',
			'The browser gives the GPS position with an accuracy of {0}m.<br>That´s not good enough for our deliverer.<br>Turn on GPS or go to an open-air location, if you´re not in a building with an valid address.': 'Der Browser gibt die GPS-Position mit einer Genauigkeit von {0}m an.<br>Das reicht für unseren Lieferanten nicht aus.<br>Schalte GPS ein und gehe nach draußen, wenn wir an einen Ort im Freien liefern sollen.',
			'Order placed': 'Bestellung übermittelt',
			'Checkout': 'Abschluss',
			'Commit': 'Absenden',
			'Payment': 'Bezahlung',
			'You have to pay': 'Zu bezahlen',
			'Cash': 'Bargeld',
			'Credit Card': 'Kreditkarte',
			'Contact': 'Kontakt',
			'Buy': 'Bestellen',
			'First Name': 'Vorname',
			'Last Name': 'Nachname',
			'Invoice Address': 'Rechnungsadresse',
			'Requires advance payment': 'Erfordert Vorkasse',
			'Your payment details are still incomplete!': 'Deine Zahlungsdaten sind noch unvollständig!',
			'Terms of service accepted': 'AGB akzeptiert',
			'Display terms of service': 'AGB anzeigen',
			'Send me e-mails about offers and promotions': 'Per E-Mail über Angebote und Aktionen informieren',
			"Remember address and contact for next order": "Adresse und Kontaktdaten für's nächste Mal in meinem Browser speichern",
			'Please accept the terms of service': 'Bitte akzeptiere die AGB',
			'Legal': 'Genehmigung',
			'Address': 'Adresse',
			'Payment Method': 'Zahlungsweise',
			'Choose Store': 'Anbieter',
			'About Us': 'Über uns',
			'My Orders': 'Bestellungen',
			'Current Order': 'Laufende Bestellung',
			'In progress': 'In Bearbeitung',
			'Show status': 'Status anzeigen',
			'No orders yet.': 'Noch keine Bestellungen.',
			'No receipts found.': 'Keine Belege gefunden.',
			'Date': 'Datum',
			'Amount': 'Betrag',
			'Receipt': 'Beleg',
			'My Account': 'Mein Konto',
			'Login': 'Anmeldung',
			'Variant': 'Variante',
			'Please select a variant': 'Wähle eine Variante aus',
			'Variants {0} - {1}': 'Varianten {0} - {1}',
			'Set the required option for {0}': 'Wähle eine Option von {0}',
			'This website uses cookies. If you continue to use the website, we will assume your consent.': 'Diese Website benutzt Cookies. Wenn du die Website weiter nutzt, gehen wir von deinem Einverständnis aus.',
			'Item added to cart': 'Artikel in den Warenkorb gelegt',
			'Do you want to buy {0} and remove all previous items from your cart at {1}?': 'Möchtest du {0} bestellen und alle vorherigen Artikel aus deinem Warenkorb bei {1} entfernen?',
			'Your shopping cart already contains items from {0}. These must be removed in order to purchase items from {1}.': 'In deinem Warenkorb befinden sich bereits Artikel von {0}. Die müssten entfernt werden, wenn du Artikel bei {1} zu kaufen willst.',
			'No item added to cart!': 'Der Artikel wurde nicht in den Warenkorb gelegt!',
			'Newsletter ordered.': 'Du wirst per E-Mail über Angebote informiert.',
			'No newsletter wanted.': 'Kein Newsletter gewünscht.',
			'All stores are currently closed. You can only schedule your order.': 'Alle Stores gerade geschlossen. Du kannst nur vorbestellen.',
			'Please select your delivery time': 'Wähle wann du deine Bestellung haben möchtest',
			'Pickup date' :  'Fertigstellung',
			'Delivery date' :  'Lieferzeitpunkt',
			'Cancel Order': 'Bestellung stornieren',
			'Refresh': 'Aktualisieren',
			'Confirmation': 'Aktuelle Bestellung',
			'Order ID': 'ID der Bestellung',
			'Order State': 'Auftragsstatus',
			'Auftragsbestätigung': 'Danke für die Bestellung',
			'Eingang': 'Warte auf Annahme',
			'Select Options and Extras': 'Extras und Optionen wählen',
			'The process has already terminated': 'Der Vorgang ist bereits beendet',
			'ended': 'Beendet',
			'Order cancelled': 'Bestellung storniert',
			'Reason': 'Grund',
			'The store has rejected this order!': 'Der Store hat deine Bestellung leider abgelehnt!',
			'Cancellation failed!': 'Stornierung nicht mehr möglich!',
			'Cancellation is no longer possible!': 'Stornierung nicht mehr möglich',
			'This deliverer doesn\'t support delivery to GPS position!': 'Dieser Lieferant unterstützt keine Lieferung an GPS-Position!',
			'Payment made': 'Zahlung erfolgt',
			'Payment refunded': 'Zahlung zurückerstattet',
			'The process is completed': 'Die Bestellung ist abgeschlossen',
			'completed': 'Abgeschlossen',
			'The order has not been accepted. Please try again later or contact the store by phone.': 'Die Bestellung wurde vom Store nicht angenommen. Bitte versuch es später noch einmal oder melde dich telefonisch im Store.',
			'Order not accepted': 'Bestellung nicht angenommen',
			'Zubereiten': 'Zubereiten',
			'Disponieren': 'Lieferung planen',
			'Warten': 'Warten',
			'Drucken': 'Drucken',
			'The automatic update will continue...': 'Die Aktualisierung ist unterbrochen, wird aber gleich fortgesetzt...',
			'Auto updates resumed.': 'Aktualisierungen wieder aktiv.',
			'Ended': 'Beendet',
			'Delivery Terms': 'Lieferbedingungen',
			'Delivery fee from {0}€ order value up to {1}km is {2}€': 'Liefergebühr ab {0}€ Bestellwert bis {1}km beträgt {2}€',
			'Delivery distance from {0}€ order value is {1}km': 'Lieferdistanz ab {0}€ {1}km',
			'Allergens': 'Allergene',
			'Additives': 'Zusatzstoffe',
			'Invoice Number': 'Rechnungsnummer',
			'cancelled': 'Storniert',
			'rejected': 'Abgelehnt',
			'Offline': 'Offline',
			'Store offline': 'Store ist offline',
			'The store is currently offline. Try ordering by phone at {0}.': 'Der Store ist gerade offline. Versuche eine telefonische Bestellung unter {0}.',
			'Receipt preview': 'Belegvorschau',
			'Store filter': 'Offenen Store finden',
			'Bigger order': 'Größere Bestellung',
			'Over {0}€': 'Über {0}€',
			'PayPal': 'PayPal',
			'PayPal hasn´t authorized the payment!': 'PayPal hat die Zahlung nicht autorisiert!',
			'PayPal has found errors in the order: "{0}"': 'PayPal hat Fehler in der Bestellung gefunden: "{0}"',
			'No store is opened now': 'Jetzt ist kein Store geöffnet'
		}
	}

	static translatePage = () => {
		document.querySelectorAll('*[i18n]:not([i18n=translated]):not([i18n=unknown])').forEach(element => {
			const input = element.innerHTML
			const translation = I18N._translate(input)
			if (translation === undefined) {
				console.debug(`No translation to ${I18N.userLang} for "${input}" at ${I18N._getDomPath(element)}`)
				element.setAttribute('i18n', 'unknown')
			}
			else if (translation) {
				element.innerHTML = translation
				element.setAttribute('i18n', 'translated')
			}
		})
	}

	static translateElement = element => {
		element.querySelectorAll('*[i18n]:not([i18n=translated]):not([i18n=unknown])').forEach(element => {
			const input = element.innerHTML
			const translation = I18N._translate(input)
			if (translation === undefined) {
				console.debug(`No translation to ${I18N.userLang} for "${input}" at ${I18N._getDomPath(element)}`)
				element.setAttribute('i18n', 'unknown')
			}
			else if (translation) {
				element.innerHTML = translation
				element.setAttribute('i18n', 'translated')
			}
		})
	}

	static translate = input => {
		const translation = this._translate(input)
		if (translation) {
			return translation
		}
		else {
			console.debug(`No translation to ${I18N.userLang} for "${input}"`, navigator.language)
		}
		return input
	}

	static _translate = input => {
		if (input) {
			const langRessources = I18N.translations[I18N.userLang]
			if (langRessources) {
				const translation = langRessources[input]
				if (translation) {
					return translation
				}
				return undefined // No translation for this string
			}
			else {
				console.warn(`No translations for ${I18N.userLang}!`, navigator.language)
				return null
			}
		}
		else {
			return null // Empty input
		}
	}

	static translateAndFormat = (template, ...args) => {
		const translatedTemplate = I18N._translate(template)
		if (translatedTemplate === undefined) {
			console.debug(`No translation to ${I18N.userLang} for "${template}"`)
			return I18N.format(template, ...args)
		}
		else if (translatedTemplate) {
			return I18N.format(translatedTemplate, ...args)
		}
		else {
			return template // Unknown language or empty template
		}
	}

	static format = (template, ...args) => {
		return template.replace(/{(\d+)}/g, (match, number) => {
			return typeof args[number] != 'undefined'
				? args[number]
				: match
		})
	}

	static _getDomPath = element => {
		const stack = []
		while (element.parentNode != null) {
			let sibCount = 0
			let sibIndex = 0
			for (var i = 0; i < element.parentNode.childNodes.length; i++) {
				const sib = element.parentNode.childNodes[i]
				if (sib.nodeName === element.nodeName) {
					if (sib === element) {
						sibIndex = sibCount
					}
					sibCount++
				}
			}
			if (element.hasAttribute('id') && element.id !== '') {
				stack.unshift(element.nodeName.toLowerCase() + '#' + element.id)
			} else if (sibCount > 1) {
				stack.unshift(element.nodeName.toLowerCase() + ':eq(' + sibIndex + ')')
			} else {
				stack.unshift(element.nodeName.toLowerCase())
			}
			element = element.parentNode
		}

		return stack.slice(1) // removes the html element
	}
}